import { FC, PropsWithChildren } from 'react';

type Props = {
	className?: string;
};

const CroatiaFlagIcon: FC<PropsWithChildren<Props>> = ({ className }) => {
	return (
		<svg
			width='20'
			height='14'
			viewBox='0 0 20 14'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			className={`${className}`}>
			<rect
				x='0.25'
				y='0.25'
				width='19.5'
				height='13.5'
				rx='1.75'
				fill='white'
				stroke='#F5F5F5'
				strokeWidth='0.5'
			/>
			<mask
				id='mask0_2332_14954'
				style={{ maskType: 'luminance' }}
				maskUnits='userSpaceOnUse'
				x='0'
				y='0'
				width='20'
				height='14'>
				<rect
					x='0.25'
					y='0.25'
					width='19.5'
					height='13.5'
					rx='1.75'
					fill='white'
					stroke='white'
					strokeWidth='0.5'
				/>
			</mask>
			<g mask='url(#mask0_2332_14954)'>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M0 4.66667H20V0H0V4.66667Z'
					fill='#FF202D'
				/>
				<path
					opacity='0.5'
					fillRule='evenodd'
					clipRule='evenodd'
					d='M7.61914 3.73339L8.09533 3.26672L8.57152 3.73339V4.66672H7.61914V3.73339ZM9.5239 3.73339L10.0001 3.26672L10.4763 3.73339V4.66672H9.5239V3.73339ZM11.9049 3.26672L11.4287 3.73339V4.66672H12.381V3.73339L11.9049 3.26672Z'
					fill='#1895DB'
				/>
				<path
					opacity='0.5'
					fillRule='evenodd'
					clipRule='evenodd'
					d='M9.04846 3.26672L8.57227 3.73339V4.66672H9.52465V3.73339L9.04846 3.26672ZM10.9532 3.26672L10.477 3.73339V4.66672H11.4294V3.73339L10.9532 3.26672Z'
					fill='#191F94'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M0 14H20V9.33337H0V14Z'
					fill='#2027AC'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M8.57152 4.66663H8.09533L7.61914 5.59996H8.57152V4.66663ZM9.5239 4.66663H10.4763V5.59996H9.5239V4.66663ZM11.4287 5.59996L10.4763 5.59996L10.4763 6.53329H9.5239V5.59996H8.57152V6.53329H7.61914V7.46663H8.57152V8.39996H7.61914V9.33329H8.57152V10.2666H9.5239L9.5239 9.33329H10.4763L10.4763 10.2666H11.4287V9.33329H12.381V8.39996H11.4287V7.46663H12.381V6.53329H11.4287V5.59996ZM11.4287 5.59996V4.66663H11.9049L12.381 5.59996H11.4287ZM10.4763 7.46663L10.4763 6.53329H11.4287V7.46663H10.4763ZM10.4763 8.39996L10.4763 7.46663H9.5239L9.5239 6.53329H8.57152V7.46663H9.5239L9.5239 8.39996H8.57152V9.33329H9.5239L9.5239 8.39996H10.4763ZM10.4763 8.39996L10.4763 9.33329H11.4287V8.39996H10.4763Z'
					fill='url(#paint0_linear_2332_14954)'
				/>
			</g>
			<defs>
				<linearGradient
					id='paint0_linear_2332_14954'
					x1='7.61914'
					y1='4.66663'
					x2='7.61914'
					y2='10.2666'
					gradientUnits='userSpaceOnUse'>
					<stop stopColor='#FF212E' />
					<stop
						offset='1'
						stopColor='#FD0D1B'
					/>
				</linearGradient>
			</defs>
		</svg>
	);
};

export default CroatiaFlagIcon;
